export default {
    intro: '听声音，正确书写！',
    wordIndex: '第{index}个单词',
    student: {
        myAnswer: '我提交的答案', noAnswer: '没有提交答案。', answer: '正确答案',
        attemptNumber: '第{number}次',
        listen: '请仔细听！<br />请集中注意力！',
        teacherReading: '老师正在亲自朗读',
        listenDirect: '请认真听老师朗读的句子！',
        placeholder: '请输入正确答案。', wrongToast: '哎呀，答错了。请重新输入',
        writeEnd: '书写结束', submitAnswer: '提交答案',
        waitingStart: '请等待老师发出开始书写的信号！',
        threeWrong: '3次答题机会已全部用完...请等待老师公布正确答案！',
    },
    teacher: {
        setting: {
            activity: '活动内容', number: '编号', title: '听写 📝',
            message: '如果现在播放句子，学生们也能听到！',
            subMessage: '仍然要播放吗？',
            optionSubMessage: '播放一次后，将不再显示确认提示。',
            confirmText: '播放',
        },
        question: '题目', intro: '请从左侧题目中选择单词。',
        ttsStart: '播放后开始书写', directReading: '亲自朗读',
        startWriting: '开始书写', completeWriting: '完成书写并公布答案',
        toast: {
            alreadyDone: '这是已经进行过的单词。',
            fiveSeconds: '开始书写后5秒才能完成书写。',
        },
        result: { title: '每题正确率', order: '顺序', question: '题目', answerRate: '正确率' },
    },
    table: { question: '题目', answerRate: '正确率', emptyMessage: '没有内容。' },
};
